import { Injectable, inject } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest';
import { Observable } from 'rxjs';
import PaymentMethodType from '../../models/payment-method.enum';
import { PaymentGatewayResponse } from '../../models/payment-gateway.model';
import { PAYMENT_GATEWAYS_ENDPOITNS } from './payment-gateways.endpoints';

@Injectable({ providedIn: 'root' })
export class PaymentGatewaysService {
  private readonly _http = inject(HttpRestService);

  getPaymentGateways(
    filterBy?: PaymentMethodType[],
  ): Observable<PaymentGatewayResponse> {
    return this._http.get<PaymentGatewayResponse>(
      PAYMENT_GATEWAYS_ENDPOITNS.GET_PAYMENT_GATEWAYS,
      filterBy?.length
        ? { params: { PaymentMethodTypes: filterBy } as never }
        : undefined,
    );
  }
}
